import { datadogRum } from '@datadog/browser-rum';

export function runDatadog(): void {
  if (process.env.NODE_ENV === 'production') {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'dashboard',
      version: process.env.REACT_APP_VERSION,
      sampleRate: 10,
      trackInteractions: true,
      env: process.env.NODE_ENV,
      replaySampleRate: 0,
    });
  }
}
